(function() {
    angular
        .module('emarket.commons')
        .directive('largeSlider', ['$mdPanel', function($mdPanel) {
            var largeSlider = {
                link: function(scope, element, attrs) {
                    var images = scope.$eval(attrs.largeSlider);
                    var panel;

                    element.css('cursor', 'pointer');
                    element.on('click', function() {
                        console.log(images);
                        if (!images) {
                            return;
                        }
                        if (panel) {
                            return panel.open();
                        }
                        $mdPanel
                            .open({
                                controller: 'LargeSliderController as vm',
                                position: $mdPanel
                                    .newPanelPosition()
                                    .absolute()
                                    .top('50%')
                                    .left('50%'),
                                templateUrl:
                  'directives/image/large-slider/large-slider.tpl.html',
                                locals: {
                                    images: images
                                },
                                animation: $mdPanel
                                    .newPanelAnimation()
                                    .openFrom(element)
                                    .duration(200)
                                    .closeTo(element)
                                    .withAnimation($mdPanel.animation.SCALE),
                                disableParentScroll: true,
                                clickOutsideToClose: true,
                                escapeToClose: true,
                                focusOnOpen: true,
                                hasBackdrop: true,
                                origin: element,
                                panelClass: 'large-slider__container'
                            })
                            .then(function(panelRef) {
                                panel = panelRef;
                            });
                    });
                    scope.$on('$destroy', function() {
                        if (panel) {
                            panel.destroy();
                        }
                    });
                }
            };
            return largeSlider;
        }]);
}());
